import React from 'react';
import OverlayWrapper from './OverlayWrapper';
import { getLabel } from '../data/labels';

const sortTypes = [
    {
        desc: 'Ordina per torneo',
        type: 'league',
    },
    {
        desc: 'Ordina per orario crescente',
        type: 'asc',
    },
    {
        desc: 'Ordina per orario decrescente',
        type: 'desc',
    },
]

export default function SortTypeDropdown(props) {
    function handleClick(type) {
        props.setSortType(type)
        props.toggle();
    }

    return (
        <OverlayWrapper id="xs-sort-type-overlay">
            <div className="xs_sortTypeOverlay z-30 absolute container top-0 left-0 right-0 bottom-0">
                <div className="h-full overflow-y-auto flex flex-col bg-cs1">
                    <div className="z-20 sticky top-0 shrink-0 h-[50px] grid grid-cols-12 items-center border-b border-b-cs7 bg-cs1">
                        <div className="col-start-1 col-end-3 justify-self-center inline-block" onClick={props.toggle}>
                            <i className="bi-x-lg font-medium text-lg text-cs-3"></i>
                        </div>
                        <div className="col-start-3 col-end-13 font-medium text-lg text-cs-3">{getLabel('live.navbar.sort_button.title')}</div>
                    </div>
                    {sortTypes.map(t => 
                        <React.Fragment key={t.type}>
                            {t.type === props.current ?
                                <div className="relative shrink-0 h-[50px] px-2 grid grid-cols-12 items-center bg-cs12 border-y border-y-cs7" onClick={() => handleClick(t.type)}>
                                    <div className="col-start-1 col-end-13 font-medium text-sm text-cs-3">{t.desc}</div>
                                    <span className="absolute left-0 top-2 bottom-2 w-[4px] bg-cs13 rounded-tr-md rounded-br-md"></span>
                                </div>
                                :
                                <div className="shrink-0 h-[50px] px-2 grid grid-cols-12 items-center border-y border-y-cs7" onClick={() => handleClick(t.type)}>
                                    <div className="col-start-1 col-end-13 font-medium text-sm text-cs-3">{t.desc}</div>
                                </div>
                            }
                        </React.Fragment>
                    )}
                </div>
            </div>
        </OverlayWrapper>
    );
}
